export enum ExportsCardId {
  AccountStatement = 'accountStatement',
  AllData = 'allData',
  Backup = 'backup',
  BalanceList = 'balanceList',
  ChartOfAccounts = 'chartOfAccounts',
  Contacts = 'contacts',
  CreditorList = 'creditorList',
  CustomerAccountStatement = 'customerAccountStatement',
  DebtorList = 'debtorList',
  EntryJournal = 'entryJournal',
  FecReport = 'fecReport',
  Products = 'products',
  VendorAccountStatement = 'vendorAccountStatement',
  XAF = 'xaf',
}
